import React from "react";
import { Card, Form, Input, Button, Modal, Select, message, DatePicker, Radio, Table as AntTable, Tag, Icon, Spin, Tooltip, Row as AntRow, Col as AntCol } from "antd";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { Row, Col, FormGroup, Label, ListGroup, Table, Spinner } from 'reactstrap';
import Media from 'react-media';

//import filterFactory from 'react-bootstrap-table2-filter';
//import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';

import 'moment/locale/fr-ca';
import locale from 'antd/es/date-picker/locale/fr_FR';

import { services } from '../../../services/services';
import { authenticationService } from "../../../services/authentication-service";
import { use_logiciel } from '../../../env';

import { numberWithCommas } from '../../../helpers/index';



const currentUser = authenticationService.currentUserValue

const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];

//const confirm = Modal.confirm;

const FormItem = Form.Item;

const moment = require('moment')

const dateFormat = 'DD/MM/YYYY';
const { RangePicker } = DatePicker;



class FacturePrincipal extends React.Component {
    state = {
        isModalVisible: false,
        isAddModalVisible: false,
        isUpdateModalVisible: false,
        loading: false,
        isListArticleVisible: false,
        isDetailsArticleVisible: false,
        isValidationValidation: false,
        repartitions: [],
        listeArticlesSelected: [],
        articles: [],
        articlesCodPro: [],
        formLayout: 'horizontal',

        usuel: "1",
        codTyp: "1",
        libCat: '',
        codeCat: '',
        emailFour: '',
        refFactFour: '',
        codAgence: '',
        modRegl: '',
        codmod: '',
        tauxAib: 0,
        fraisTransport: 0,
        cleRepartition: 0,
        dateFact: moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY'),
        dateEnCours: moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY'),
        startDate: moment(),
        endDate: moment(),
        refFact: '',
        etatCmde: 'EN COURS',
        puRemise: 0,
        autreFrais: 0,
        montantRemise: 0,
        //puRemise: 0,
        qtCommander: 0,

        factures: [],
        clients: [],
        //agences: [],
        gender: 'M',
        raisonSociale: '',
        codClient: '',
        mentionClient: 'NOUVEAU CLIENT',
        typeClient: 'CLIENT ORDINAIRE',
        //usuel: '1',
        dateNaissance: moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY'),
        ifu: '',
        observation: '',
        numeroCarte: '',

        waitingEndMsg: '',
        isLoading: true,
        agences: [],
        searchText: ''
    }

    handleSearch = (e) => {
        this.setState({ searchText: e.target.value })
    }

    handleRefresh = () => {
        const startDate = moment(this.state.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
        const endDate = moment(this.state.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
        this.setState({ isLoading: true, factures: [] });
        services.getFactures(this.state.dateEnCours, this.state.codAgence || '', startDate, endDate)
            .then(factures => {
                this.setState({ factures: factures || [], isLoading: false });
                if (!factures || !Array.isArray(factures) || factures.length === 0) {
                    this.setState({ waitingEndMsg: "Vous n'avez aucune Facture pour cette période!" });
                }
            })
            .catch(() => this.setState({ isLoading: false }));
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }
    componentDidMount() {
        const startDate = moment(new Date(), 'DD/MM/YYYY').format('YYYY-MM-DD')
        const endDate = moment(new Date(), 'DD/MM/YYYY').format('YYYY-MM-DD')
        //const dateEnCours= moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY');
        ////console.log('Date', this.state.dateEnCours)
        services.getFactures('', '', startDate, endDate/*this.state.dateEnCours*/)
            .then(factures => {
                this.setState({ factures: factures || [], isLoading: false })
                if (!factures || !Array.isArray(factures) || factures.length === 0) {
                    this.setState({ waitingEndMsg: `Vous n'avez aucune Facture pour cette période!` })
                }
            })
            .catch(() => {
                this.setState({ isLoading: false })
            })
        services.getClients()
            .then(clients => {
                //  //console.log('clients', clients)
                this.setState({ clients })
            })

        services.getStocksAgence()
            .then(articles => {
                //  //console.log('articles', articles)
                this.setState({ articles })
            })

        services.getAllAgences()
            .then(agences => {
                //  //console.log('agences', agences)
                this.setState({ agences })
            })
    }

    handleChangeAgence = (value) => {

        const startDate = moment(this.state.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
        const endDate = moment(this.state.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
        this.setState({ codAgenceChange: value })
        this.setState({ isLoading: true, waitingEndMsg: '', factures: [] })
        //  //console.log("AGENCE CHANGE", this.state.dateEnCours,value, startDate, endDate)
        services.getFactures(this.state.dateEnCours, value, startDate, endDate/*this.state.dateEnCours*/)
            .then(factures => {
                //  //console.log('factures', factures)
                this.setState({ factures: factures, codAgence: value, isLoading: false, })

                setTimeout(() => {

                    // //console.log("real articles", factures)
                    if (!factures || !Array.isArray(factures)
                        || !factures.length > 0) {
                        this.setState({ isLoading: false, waitingEndMsg: `Vous n'avez aucune Facture actuellement pour cette Agence` })
                    }
                }, 500)
            })
        /*services.getFacturesGlobale(value, this.state.dateEnCours, startDate, endDate)
            .then(factures => {
              //  //console.log('factures', factures)
                this.setState({ factures })

                setTimeout(() => {

                    // //console.log("real articles", factures)
                    if (!factures || !Array.isArray(factures)
                        || !factures.length > 0) {
                        this.setState({ isLoading: false, waitingEndMsg: "Vous n'avez aucune Facture actuellement pour cette Agence!" })
                    }
                }, 500)
            })*/
    }


    handleAddOpen = () => {
        this.setState({
            dateFact: moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY'),
            codClient: '',
            observation: '',
            modRegl: 'Cash',
            codmod: 'ESPECES',
            montantRemise: 0,
            fraisTransport: 0,
            autreFrais: 0,
            tauxAib: 0,
            totalTva: 0,
            netHT: 0,
            tauxRemise: 0,
            netCommercial: 0,
            montantTtc: 0,
            montantAib: 0,
            netaPayer: 0,
            montFact: 0,
            refFact: '',
            isAddModalVisible: !this.state.isAddModalVisible,
            articlesCodPro: [],
            listeArticlesSelected: [],
            loading: false,

        });
    };

    handleCancelAdd = () => {
        this.setState({
            isAddModalVisible: !this.state.isAddModalVisible,
            codCat: '',

            libCat: '',
            loading: false,

        })
    }

    handleAddFacture = () => {
        const {
            //dateFact,
            codClient,
            observation,
            modRegl,
            codmod,
            montantRemise,
            fraisTransport,
            autreFrais,
            tauxAib,
            refFact,

            listeArticlesSelected,

        } = this.state


        if (codClient === '') {
            message.warning('Veuillez sélectionner un Client', 5)
            return;
        }

        if (!listeArticlesSelected.length > 0 || listeArticlesSelected === null) {
            message.warning('Vous devriez au moins sélectionner un article', 5)
            return;
        }

        const totalTva = listeArticlesSelected && listeArticlesSelected.length ?
            listeArticlesSelected.reduce(function (prev, cur) {
                return prev + parseFloat((cur.puUtilise * cur.qtCommander * cur.tauxTva) / 100)
            }, 0) : 0

        const netHT = listeArticlesSelected && listeArticlesSelected.length ?
            listeArticlesSelected.reduce(function (prev, cur) {
                return prev + parseFloat(cur.puUtilise * cur.qtCommander)
            }, 0) : 0

        const tauxRemise = ((100 * parseFloat(montantRemise) / netHT))

        const netCommercial = (parseFloat(netHT) - parseFloat(montantRemise))

        const montantTtc = (parseFloat(netCommercial) + parseFloat(totalTva) + parseFloat(fraisTransport) + parseFloat(autreFrais))

        const montantAib = ((tauxAib * montantTtc) / 100)


        const netaPayer = parseFloat(montantTtc) + parseFloat(montantAib) /*+ parseFloat(fraisTransport)*/;

        const montFact = netaPayer;

        this.setState({ loading: true })
        let req = {
            dateFact: moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY'),
            codClient,
            observation,
            modRegl,
            codmod,
            montantRemise,
            fraisTransport,
            autreFrais,
            tauxAib,
            totalTva,
            netHT,
            tauxRemise,
            netCommercial,
            montantTtc,
            montantAib,
            netaPayer,
            montFact,
            refFact,


            listeArticlesSelected,


        }
        ////console.log('REQUETE', req)

        ////console.log('REQ ADD APPROVISIONNEMENT', req)
        services.addFacture(req)
            .then(result => {
                //  //console.log(result)
                this.setState({
                    dateFact: moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY'),
                    codClient: '',
                    observation: '',
                    modRegl: '',
                    codmod: '',
                    montantRemise: '',
                    fraisTransport: '',
                    autreFrais: '',
                    tauxAib: '',
                    totalTva: '',
                    netHT: '',
                    tauxRemise: '',
                    netCommercial: '',
                    montantTtc: '',
                    montantAib: '',
                    netaPayer: '',
                    montFact: '',
                    refFact: '',
                    loading: false,
                    waitingEndMsg: '',
                    listeArticlesSelected: [],

                    isAddModalVisible: !this.state.isAddModalVisible,

                })
                message.success('Facture ajouter avec succès', 10)
                const startDate = moment(new Date(this.state.startDate), 'DD/MM/YYYY').format('YYYY-MM-DD')
                const endDate = moment(new Date(this.state.endDate), 'DD/MM/YYYY').format('YYYY-MM-DD')

                services.getFactures(this.state.dateEnCours, this.state.codAgence, startDate, endDate/*this.state.dateEnCours*/)
                    .then(factures => {
                        this.setState({ factures: factures || [], isLoading: false })
                        if (!factures || !Array.isArray(factures) || factures.length === 0) {
                            this.setState({ waitingEndMsg: `Vous n'avez aucune Facture pour cette période!` })
                        }
                    })
                    .catch(() => {
                        this.setState({ isLoading: false })
                    })
            })

            .catch(() => {
                message.error('Une erreur est survenue lors de l\'ajout, Veuillez réessayer plus tard', 10)
                this.setState({ loading: false })

            });
    }

    onDateChange = (date, dateString) => {
        this.setState({ isLoading: true, factures: [] })

        const startDate = moment(dateString[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
        const endDate = moment(dateString[1], 'DD/MM/YYYY').format('YYYY-MM-DD')

        services.getFactures(this.state.dateEnCours, this.state.codAgence, startDate, endDate)
            .then(factures => {
                this.setState({ factures: factures || [], isLoading: false })
                if (!factures || !Array.isArray(factures) || factures.length === 0) {
                    this.setState({ waitingEndMsg: `Vous n'avez aucune Facture pour cette période!` })
                }
            })
            .catch(() => {
                this.setState({ isLoading: false })
            })
        this.setState({ startDate: dateString[0], endDate: dateString[1] })
    }

    /* handleUpdateRepartition = () => {
         const {
             repartitionId,
             dateRepartition,
             observation,
             codAgence,
 
             listeArticlesSelected,
 
         } = this.state
 
 
         if (codAgence === '') {
             message.warning('Veuillez sélectionner une Agence', 5)
             return;
         }
 
         if (!listeArticlesSelected.length > 0 || listeArticlesSelected === null) {
             message.warning('Vous devriez au moins sélectionner un article', 5)
             return;
         }
 
 
         let req = {
             repartitionId,
             dateRepartition,
             observation,
             codAgence,
 
             listeArticlesSelected,
         }
 
         services.updateRepartition(repartitionId, req)
             .then(result => {
               //  //console.log(result)
                 this.setState({
                     repartitionId: '',
                     dateRepartition: '',
                     observation: '',
                     codAgence: '',
                     listeArticlesSelected: [],
                     isUpdateModalVisible: !this.state.isUpdateModalVisible,
 
                 })
                 message.success('Répartition modifier avec succès', 10)
 
                 services.getFactures()
                     .then(factures => {
                         this.setState({ factures })
                     })
 
             })
 
             .catch(() => {
                 message.error('Une erreur est survenue lors de la modification, Veuillez réessayer plus tard', 10)
             });
     }
 
     handleDelete = (row) => {
         this.setState({
             repartitionId: row.id,
         })
 
     }
 
     handleDeleteApprovisionnement = () => {
 
         const { repartitionId } = this.state
 
         services.deleteRepartition(repartitionId)
             .then(del => {
                 ////console.log('delete user', del)
                 message.success('Répartition supprimer avec succès', 10)
                 services.getFactures()
                     .then(factures => {
                         this.setState({ factures })
                     })
 
             })
             .catch(() => {
                 message.error('Une erreur est survenue lors de la suppression, Veuillez réessayer plus tard', 10)
             });
 
     }
 
     handleValider = (row) => {
         this.setState({
             repartitionId: row.id,
             isValidationValidation: !this.state.isValidationValidation
         })
 
     }
     handleCloseValidation = () => {
         this.setState({ isValidationValidation: !this.state.isValidationValidation, codeEntre: '' })
     }
 
     handleValiderRepartition = () => {
 
         const { repartitionId } = this.state
 
         services.validerRepartition(repartitionId)
             .then(del => {
                 ////console.log('delete user', del)
                 message.success('Répartition Valider avec succès', 10)
                 this.setState({
                     isValidationValidation: !this.state.isValidationValidation
                 })
                 services.getFactures()
                     .then(factures => {
                         this.setState({ factures })
                     })
 
             })
             .catch(() => {
                 message.error('Une erreur est survenue lors de la validation, Veuillez réessayer plus tard', 10)
             });
 
     }
 
     handleUpdateOpen = (row) => {
         this.setState({
             isUpdateModalVisible: !this.state.isUpdateModalVisible,
             repartitionId: row.id,
             dateRepartition: row.dateRepartition,
             observation: row.observation,
             codAgence: row.codAgence,
             //codAgence: `${row.codAgence}`,
             listeArticlesSelected: row.listeArticlesSelected && row.listeArticlesSelected.length ?
                 row.listeArticlesSelected.map((details, k) => {
                     return {
                         qtEntree: details.qtEntree,
                         qteStock: details && details.stock ? details.stock.qteStock : '',
                         qteStockEnCoursValidation: details && details.stock ? details.stock.qteStockEnCoursValidation : '',
                         designation: details && details.article ? details.article.designation : '',
                         codProd: details && details.article ? details.article.codPro : '',
 
                     }
                 }) : [],
 
             articlesCodPro: row.listeArticlesSelected && row.listeArticlesSelected.length ?
                 row.listeArticlesSelected.map((details, k) => {
                     return details && details.article ? details.article.codPro : ''
                 }) : [],
 
         })
 
     }
 
     handleCancelUpdate = () => {
         this.setState({
             isUpdateModalVisible: !this.state.isUpdateModalVisible,
             dateRepartition: '',
             observation: '',
             codAgence: '',
 
             listeArticlesSelected: [],
 
         })
     }
 
     */


    handleView = (row) => {
        const userObj = row && row.userInfo ? row.userInfo : {};
        const nomAgent = userObj.prenomAgent 
            ? `${userObj.prenomAgent} ${userObj.nomAgent || ''}`.trim()
            : `${userObj.firstName || ''} ${userObj.lastName || ''}`.trim();

        const nomAgence = (row && row.agences && row.agences.nomAgence) || row.nomAgence || '';
        const clientName = (row && row.clients && row.clients.raisonSociale) || row.raisonSociale || '';

        const formattedArticles = row.listeArticlesSelected && row.listeArticlesSelected.length ?
            row.listeArticlesSelected.map((details) => {
                const puBrut = parseFloat(details.puBrut || details.puUtilise || 0);
                const puRemise = parseFloat(details.puRemise || 0);
                const puUtilise = parseFloat(details.puUtilise || (puBrut - puRemise) || 0);
                return {
                    puRemise: puRemise,
                    qtCommander: parseFloat(details.qtCommander || 1),
                    codTva: details.codTva,
                    tauxTva: parseFloat(details.tauxTva || 0),
                    puAchat: details.puAchat || (puBrut - puRemise),
                    puBrut: puBrut,
                    puUtilise: puUtilise,
                    codAgence: details.codAgence || row.codAgence,
                    designation: (details && details.article ? details.article.designation : details.designation) || '',
                    codProd: (details && details.article ? details.article.codPro : details.codProd) || '',
                };
            }) : [];

        this.setState({
            isModalVisible: true,
            numFact: row.numFact || '',
            dateFact: row.dateFact || '',
            codClient: row.codClient || '',
            clientName: clientName,
            observation: row.observation || '',
            modRegl: row.modRegl || 'Cash',
            codmod: row.codmod || 'ESPECES',
            montantRemise: parseFloat(row.montantRemise || 0),
            fraisTransport: parseFloat(row.fraisTransport || 0),
            autreFrais: parseFloat(row.autreFrais || 0),
            tauxAib: parseFloat(row.tauxAib || 0),
            totalTva: parseFloat(row.totalTva || 0),
            netHT: parseFloat(row.netHT || 0),
            tauxRemise: parseFloat(row.tauxRemise || 0),
            netCommercial: parseFloat(row.netCommercial || 0),
            montantTtc: parseFloat(row.montantTtc || 0),
            montantAib: parseFloat(row.montantAib || 0),
            netaPayer: parseFloat(row.netaPayer || row.montFact || 0),
            montFact: parseFloat(row.montFact || 0),
            refFact: row.refFact || '',
            nomAgence: nomAgence,
            nomAgent: nomAgent,
            listeArticlesSelected: formattedArticles,
        });

        if (!formattedArticles.length && row.numFact) {
            const startDate = moment(this.state.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
            const endDate = moment(this.state.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
            services.getDetailsFactures(this.state.dateEnCours, startDate, endDate, row.codAgence || '')
                .then(allDetails => {
                    if (allDetails && allDetails.length) {
                        const matching = allDetails.filter(d => (d.numFact === row.numFact) || (d.facture && d.facture.numFact === row.numFact));
                        if (matching.length) {
                            this.setState({
                                listeArticlesSelected: matching.map(details => {
                                    const puBrut = parseFloat(details.puBrut || details.puUtilise || 0);
                                    const puRemise = parseFloat(details.puRemise || 0);
                                    const puUtilise = parseFloat(details.puUtilise || (puBrut - puRemise) || 0);
                                    return {
                                        puRemise: puRemise,
                                        qtCommander: parseFloat(details.qtCommander || 1),
                                        codTva: details.codTva,
                                        tauxTva: parseFloat(details.tauxTva || 0),
                                        puAchat: details.puAchat || (puBrut - puRemise),
                                        puBrut: puBrut,
                                        puUtilise: puUtilise,
                                        codAgence: details.codAgence || row.codAgence,
                                        designation: (details.article && details.article.designation) || details.designation || '',
                                        codProd: (details.article && details.article.codPro) || details.codProd || '',
                                    };
                                })
                            });
                        }
                    }
                })
                .catch(() => {});
        }
    };

    handleCancel = () => {
        this.setState({
            isModalVisible: false,
            dateRepartition: '',
            observation: '',
            codAgence: '',

            listeArticlesSelected: [],
        });
    }


    //clients
    handleCancelAddClient = () => {
        this.setState({
            isAddClientModalVisible: !this.state.isAddClientModalVisible,
            codClient: '',
            raisonSociale: '',
            ifu: '',
            adresse: '',
            contact: '',
            contact2: '',
            gender: 'M',
            usuel: '1',
            mentionClient: 'NOUVEAU CLIENT',
            dateNaissance: moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY'),
            typeClient: 'CLIENT ORDINAIRE',
            siteWeb: '',
            email: '',
            profession: '',
            numeroCarte: '',
        })
    }


    handleAddClient = () => {
        const {
            raisonSociale,
            ifu,
            adresse,
            contact,
            contact2,
            gender,
            usuel,
            dateNaissance,
            typeClient,
            siteWeb,
            email,
            profession,
            mentionClient,
            numeroCarte,
        } = this.state


        if (raisonSociale === '') {
            message.warning('Veuillez renseigner le champ Raison sociale', 5)
            return;
        }
        if (contact === '') {
            message.warning('Veuillez renseigner le champ Téléphone', 5)
            return;
        }


        let req = {
            raisonSociale: raisonSociale.toUpperCase(),
            ifu,
            adresse,
            contact,
            contact2,
            gender,
            usuel,
            dateNaissance,
            typeClient,
            siteWeb,
            email,
            profession,
            mentionClient,
            numeroCarte,

        }
        services.addClient(req)
            .then(result => {
                //  //console.log(result)
                this.setState({
                    raisonSociale: '',
                    ifu: '',
                    adresse: '',
                    contact: '',
                    contact2: '',
                    gender: 'M',
                    usuel: '1',
                    mentionClient: 'NOUVEAU CLIENT',
                    dateNaissance: moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY'),
                    typeClient: 'CLIENT ORDINAIRE',
                    siteWeb: '',
                    email: '',
                    profession: '',
                    numeroCarte: '',
                    isAddClientModalVisible: !this.state.isAddClientModalVisible,

                })
                message.success('Client ajouter avec succès', 10)

                services.getClients()
                    .then(clients => {
                        this.setState({ clients })
                    })

            })

            .catch((err) => {
                message.error(err, 10)
            });
    }


    handleChangeGender = (value) => {
        this.setState({ gender: value })
    }


    onChangeMention = e => {
        ////console.log('radio4 checked', e.target.value);
        this.setState({
            mentionClient: e.target.value,
        });
    };

    handleChangeUsuel = (value) => {
        this.setState({ usuel: value })
    }

    handleChangeDate = (date, dateString) => {
        //  //console.log(dateString, moment(dateString).format('DD/MM/YYYY'), moment(date, dateFormatList[0]));
        this.setState({ dateNaissance: dateString })
    }

    handleChangeTypeClient = (value) => {
        this.setState({ typeClient: value })
    }
    //FIN FOURNISSEUR


    handleChangeClient = (value) => {
        this.setState({ codClient: value })
    }

    handleChangeAib = (value) => {
        this.setState({ tauxAib: value })
    }


    handleChangeTypeReglement = (value) => {
        this.setState({ modRegl: value })
    }

    handleChangeModReglem = (value) => {
        this.setState({ codmod: value })
    }

    openListArticleModal = () => {
        services.getStocksAgence()
            .then(articles => {
                ////console.log('ARTICLES', articles)

                this.setState({
                    articles: articles.filter(x => !this.state.articlesCodPro.some(articleCod => articleCod === x.codProd)),
                })
            })
        this.setState({ isListArticleVisible: !this.state.isListArticleVisible })
    }


    onRechercheArticleChange = (e) => {
        services.getStocksAgence(e.target.value.toUpperCase())
            .then(articles => {
                //  //console.log('ARTICLES', articles)

                this.setState({
                    articles: articles.filter(x => !this.state.articlesCodPro.some(articleCod => articleCod === x.codProd)),
                })
            })
    }

    handleArticleSelected = () => {

        const {
            puRemise,
            qtCommander,
            codTva,

            puAchat,
            puBrut,



            qteStock,
            //qtEntree,
            qteStockEnCoursValidation,
            //puEntree,


            article,
            articles,
        } = this.state

        if (qtCommander === '' || qtCommander === 0) {
            message.warning('Veuillez préciser la Quantité à Répartir', 6)
            return;
        }
        if (qtCommander > (parseFloat(qteStock) - parseFloat(qteStockEnCoursValidation))) {
            message.warning('La quantité entrée est supérieure à la quantité disponible, Veuillez éffectuer un Approvisionnement d\'abord', 6)
            return;
        }

        if (parseFloat(puRemise) > parseFloat(puBrut) || parseFloat(puRemise) === parseFloat(puBrut)) {
            message.warning('Le Prix unitaire remise entrée est supérieure ou égal au prix unitaire Brut, Veuillez modifier', 6)
            return;
        }

        const articleCod = article.codProd

        let tauxTva =
            (this.state.codTva === "A" || this.state.codTva === "C" || this.state.codTva === "E" || this.state.codTva === "F") ?//&&
                "0"
                :
                //||
                //(this.state.codTva === "B" || this.state.codTva === "D") &&
                "18";


        this.setState({
            listeArticlesSelected: [
                ...this.state.listeArticlesSelected,
                {
                    puRemise: puRemise,
                    qtCommander: qtCommander,
                    codTva: codTva,
                    tauxTva: parseFloat(tauxTva),
                    puAchat: puAchat,
                    puBrut: puBrut,
                    //puRemise: puRemise,
                    puUtilise: (parseFloat(puBrut) - parseFloat(puRemise)),

                    //qtEntree: qtEntree,
                    qteStock: qteStock,
                    qteStockEnCoursValidation: qteStockEnCoursValidation,

                    codProd: article.codProd,
                    designation: article.article ? article.article.designation : ''

                }
            ],

        })
        this.setState(() => ({
            articlesCodPro: [...this.state.articlesCodPro, articleCod],
            articles: articles.filter(x => !this.state.articlesCodPro.some(articleCod => articleCod === x.codProd) && x.codProd !== articleCod),
            isDetailsArticleVisible: !this.state.isDetailsArticleVisible,
            isListArticleVisible: !this.state.isListArticleVisible,
            qtEntree: '',
        }))
        // //console.log('ArticleCod & articles', this.state.articlesCodPro, articles)
    }


    handleDeleteArticlesSelected = (article) => {

        const { listeArticlesSelected, articlesCodPro } = this.state
        //  //console.log('ID Art', article, listeArticlesSelected)

        this.setState({
            listeArticlesSelected: [...listeArticlesSelected.filter(x => x.codProd !== article.codProd)],
            articlesCodPro: [...articlesCodPro.filter(x => x !== article.codProd)]
        })


    }

    openDetailArticleModal = (article) => {
        this.setState({
            codTva: article.article ? article.article.codTvaVente : '',
            //tauxTva,
            puAchat: article.article ? article.article.puAchat : 0,
            puBrut: parseFloat(article.article ? article.article.puVente : 0),

            designation: article ? article.article.designation : '',
            article: article,
            qteStock: article.qteStock,
            qteStockEnCoursValidation: article.qteStockEnCoursValidation,
            isDetailsArticleVisible: !this.state.isDetailsArticleVisible,
            qtCommander: 0,
            puRemise: 0,
            //codTva: '',
        })
    }


    closeDetailArticleModal = () => {
        this.setState({ isDetailsArticleVisible: false })
    }

    handleChangeEtatCmde = (value) => {
        this.setState({ etatCmde: value });
        services.getFactures(value)
            .then(factures => {
                // //console.log('factures', repartitions)
                this.setState({ factures })


            })

    }

    handleChangeDateFiltre = (date, dateString) => {
        ////console.log(dateString, moment(dateString).format('DD/MM/YYYY'), moment(date, dateFormatList[0]));
        this.setState({ dateEnCours: dateString })
        this.setState({ isLoading: true, waitingEndMsg: '' })

        ////console.log('Date2',dateString, moment(dateString).format('DD/MM/YYYY'))
        ////console.log('Date3', moment(dateString, dateFormatList[0]))

        services.getFactures(dateString)
            .then(factures => {
                this.setState({ factures: factures || [], isLoading: false })
                if (!factures || !Array.isArray(factures) || factures.length === 0) {
                    this.setState({ waitingEndMsg: `Vous n'avez aucune Facture pour cette période!` })
                }
            })
            .catch(() => {
                this.setState({ isLoading: false })
            })
    }


    render() {
        const {
            isModalVisible,
            loading,

            codAgenceChange,
            //dateEnCours,
            dateFact,
            observation,
            //codAgence,
            modRegl,
            // montantAp,
            codmod,
            refFact,
            numFact,
            montFact,
            qtCommander,
            puRemise,
            puBrut,
            // puUtilise,
            agences,


            // etatCmde,
            //numPoint,
            //valider,
            ///  datValid,

            fraisTransport,
            listeArticlesSelected,
            articles,

            // repartitions,
            qteStockEnCoursValidation,



            isAddClientModalVisible,
            isAddModalVisible,
            //isUpdateModalVisible,
            isListArticleVisible,
            isDetailsArticleVisible,
            isValidationValidation,

            // qtEntree,

            codClient,
            raisonSociale,
            ifu,
            adresse,
            contact,
            contact2,
            gender,
            //  usuel,
            dateNaissance,
            typeClient,
            siteWeb,
            email,
            profession,
            mentionClient,
            //numeroCarte,
            clients,

            factures,

            qteStock,

            formLayout,

            tauxAib,
            //montantAib,
            //montantTtc,
            //netCommercial,
            //tauxRemise,
            montantRemise,
            autreFrais, //n'existe pas

            nomAgence,
            nomAgent,

            designation,

            isLoading,
            waitingEndMsg,

            startDate,
            endDate,
            searchText,
            clientName,
        } = this.state

        const titleDetailsArticle = `Complèter les détails pour l'Article ${designation || ''}`;

        const nbresArticles = listeArticlesSelected && listeArticlesSelected.length ?
            listeArticlesSelected.reduce(function (prev, cur) {
                return prev + parseFloat(cur.qtCommander || 0)
            }, 0) : 0

        const totalTva = listeArticlesSelected && listeArticlesSelected.length ?
            listeArticlesSelected.reduce(function (prev, cur) {
                return prev + parseFloat((cur.puUtilise * cur.qtCommander * (cur.tauxTva || 0)) / 100)
            }, 0) : parseFloat(this.state.totalTva || 0);

        const netHT = listeArticlesSelected && listeArticlesSelected.length ?
            listeArticlesSelected.reduce(function (prev, cur) {
                return prev + parseFloat(cur.puUtilise * cur.qtCommander)
            }, 0) : parseFloat(this.state.netHT || 0);

        const netCommercial = netHT > 0 ? (parseFloat(netHT) - parseFloat(montantRemise || 0)) : parseFloat(this.state.netCommercial || this.state.netHT || 0);
        const montantTtc = netHT > 0 ? (parseFloat(netCommercial) + parseFloat(totalTva) + parseFloat(fraisTransport || 0) + parseFloat(autreFrais || 0)) : parseFloat(this.state.montantTtc || this.state.montFact || 0);
        const montantAib = ((parseFloat(tauxAib || 0) * montantTtc) / 100);
        const netaPayer = montantTtc > 0 ? (parseFloat(montantTtc) + parseFloat(montantAib)) : parseFloat(this.state.netaPayer || this.state.montFact || 0);

        //const montantAp = netaPayer;



        const InputGroup = Input.Group;
        const Option = Select.Option;

        const formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { xs: 24, sm: 6 },
            wrapperCol: { xs: 24, sm: 14 },
        } : null;

        const totalChiffre = factures && factures.length ?
            factures.reduce((prev, cur) => prev + (parseFloat(cur.montFact) || 0), 0) : 0;
        const totalFactures = factures ? factures.length : 0;
        const panierMoyen = totalFactures > 0 ? Math.round(totalChiffre / totalFactures) : 0;
        const uniqueClients = new Set(
            (factures || [])
                .map(f => (f.clients && (f.clients.id || f.clients.raisonSociale)) || f.codClient || f.raisonSociale)
                .filter(Boolean)
        ).size;

        const filteredFactures = (factures || []).filter(item => {
            if (!searchText) return true;
            const q = searchText.toLowerCase().trim();
            const num = (item.numFact || '').toString().toLowerCase();
            const ref = (item.refFact || '').toLowerCase();
            const client = ((item.clients && item.clients.raisonSociale) || item.raisonSociale || '').toLowerCase();
            const agent = (item.userInfo ? `${item.userInfo.prenomAgent || ''} ${item.userInfo.nomAgent || ''}` : '').toLowerCase();
            const agence = ((item.agences && item.agences.nomAgence) || '').toLowerCase();
            const date = item.dateFact ? moment(new Date(item.dateFact), 'DD/MM/YYYY').format('DD/MM/YYYY').toLowerCase() : '';
            const heure = (item.heure || '').toString().toLowerCase();
            const montant = (item.montFact || '').toString().toLowerCase();
            return num.includes(q) || ref.includes(q) || client.includes(q) || agent.includes(q) || agence.includes(q) || date.includes(q) || heure.includes(q) || montant.includes(q);
        });

        const columnsFactures = [
            {
                title: 'N°',
                dataIndex: 'numFact',
                key: 'numFact',
                width: 75,
                align: 'center',
                sorter: (a, b) => (parseFloat(a.numFact) || 0) - (parseFloat(b.numFact) || 0),
                render: (text) => (
                    <span style={{ fontWeight: 600, color: '#1890ff', background: '#e6f7ff', padding: '2px 8px', borderRadius: '10px', fontSize: '12px' }}>
                        #{text || '-'}
                    </span>
                )
            },
            {
                title: 'Référence',
                dataIndex: 'refFact',
                key: 'refFact',
                width: 140,
                sorter: (a, b) => (a.refFact || '').localeCompare(b.refFact || ''),
                render: (text) => (
                    <Tag color="geekblue" style={{ fontWeight: 600, fontFamily: 'monospace' }}>
                        {text || '-'}
                    </Tag>
                )
            },
            {
                title: 'Date',
                dataIndex: 'dateFact',
                key: 'dateFact',
                width: 110,
                align: 'center',
                sorter: (a, b) => new Date(a.dateFact || 0) - new Date(b.dateFact || 0),
                render: (text) => (
                    <span style={{ color: '#595959', whiteSpace: 'nowrap' }}>
                        {text ? moment(new Date(text), 'DD/MM/YYYY').format('DD/MM/YYYY') : '-'}
                    </span>
                )
            },
            {
                title: 'Heure Création',
                key: 'heure',
                width: 125,
                align: 'center',
                render: (text, row) => {
                    if (row.heure) return <span style={{ color: '#595959' }}>{row.heure}</span>;
                    if (row.createdAt) {
                        const date = new Date(parseInt(row.createdAt));
                        const options = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };
                        return <span style={{ color: '#595959' }}>{date.toLocaleTimeString('fr-FR', options)}</span>;
                    }
                    return <span style={{ color: '#bfbfbf' }}>-</span>;
                }
            },
            {
                title: 'Clients',
                key: 'clients',
                sorter: (a, b) => {
                    const nomA = (a.clients && a.clients.raisonSociale) || a.raisonSociale || '';
                    const nomB = (b.clients && b.clients.raisonSociale) || b.raisonSociale || '';
                    return nomA.localeCompare(nomB);
                },
                render: (text, row) => {
                    const nom = (row.clients && row.clients.raisonSociale) || row.raisonSociale || '-';
                    return (
                        <div style={{ fontWeight: 500, color: '#262626', display: 'flex', alignItems: 'center' }}>
                            <Icon type="user" style={{ color: '#1890ff', marginRight: 6, fontSize: 13 }} />
                            <span>{nom}</span>
                        </div>
                    );
                }
            },
            {
                title: 'Agents',
                key: 'userInfo',
                width: 160,
                render: (text, row) => {
                    if (row.userInfo) {
                        const agent = `${row.userInfo.prenomAgent || ''} ${row.userInfo.nomAgent || ''}`.trim();
                        return <span style={{ color: '#595959' }}>{agent || '-'}</span>;
                    }
                    return <span style={{ color: '#bfbfbf' }}>-</span>;
                }
            },
            {
                title: 'Agence',
                key: 'agences',
                width: 140,
                align: 'center',
                render: (text, row) => {
                    const nom = (row.agences && row.agences.nomAgence) || '-';
                    return <Tag color="blue">{nom}</Tag>;
                }
            },
            {
                title: 'Montant Total',
                dataIndex: 'montFact',
                key: 'montFact',
                width: 170,
                align: 'right',
                sorter: (a, b) => (parseFloat(a.montFact) || 0) - (parseFloat(b.montFact) || 0),
                render: (text) => (
                    <span style={{ fontWeight: 700, color: '#096dd9', fontSize: '13px', whiteSpace: 'nowrap' }}>
                        {numberWithCommas(parseFloat(text || 0))} F CFA
                    </span>
                )
            },
            {
                title: 'Action',
                key: 'action',
                width: 95,
                align: 'center',
                render: (text, row) => (
                    <Button
                        type="primary"
                        size="small"
                        icon="eye"
                        style={{ borderRadius: 4, backgroundColor: '#096dd9', borderColor: '#096dd9' }}
                        onClick={() => this.handleView(row)}
                        title="Visualiser"
                    >
                        Détails
                    </Button>
                )
            }
        ];

        return (
            <div>
                <Card
                    bordered={false}
                    className="gx-card"
                    style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.06)' }}
                >
                    {/* EN-TETE TITRE & COMPTEUR */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', marginBottom: 20 }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{
                                width: 42,
                                height: 42,
                                borderRadius: 10,
                                background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: 12,
                                boxShadow: '0 4px 10px rgba(24,144,255,0.3)'
                            }}>
                                <Icon type="file-text" style={{ fontSize: 22, color: '#fff' }} />
                            </div>
                            <div>
                                <h2 style={{ margin: 0, fontWeight: 700, fontSize: 20, color: '#1f1f1f' }}>
                                    Gestion des Factures
                                </h2>
                                <span style={{ fontSize: 13, color: '#8c8c8c' }}>
                                    Suivi et consultation détaillée des factures émises
                                </span>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                            <Tag color="geekblue" style={{ fontSize: 13, padding: '4px 12px', borderRadius: 14 }}>
                                {totalFactures} Facture{totalFactures > 1 ? 's' : ''}
                            </Tag>
                        </div>
                    </div>

                    {/* 4 CARTES KPI STATISTIQUES */}
                    <AntRow gutter={[16, 16]} style={{ marginBottom: 24 }}>
                        <AntCol xs={24} sm={12} lg={6}>
                            <div style={{
                                background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                                borderRadius: 10,
                                padding: '16px 18px',
                                color: '#fff',
                                boxShadow: '0 4px 12px rgba(24, 144, 255, 0.25)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}>
                                <div>
                                    <div style={{ fontSize: 11, opacity: 0.85, textTransform: 'uppercase', letterSpacing: 0.5 }}>Factures Émises</div>
                                    <div style={{ fontSize: 22, fontWeight: 700, marginTop: 4 }}>{numberWithCommas(totalFactures)}</div>
                                    <div style={{ fontSize: 11, opacity: 0.8, marginTop: 2 }}>Sur la période</div>
                                </div>
                                <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: 8, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Icon type="file-text" style={{ fontSize: 20, color: '#fff' }} />
                                </div>
                            </div>
                        </AntCol>
                        <AntCol xs={24} sm={12} lg={6}>
                            <div style={{
                                background: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
                                borderRadius: 10,
                                padding: '16px 18px',
                                color: '#fff',
                                boxShadow: '0 4px 12px rgba(82, 196, 26, 0.25)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}>
                                <div style={{ minWidth: 0, flex: 1, paddingRight: 6 }}>
                                    <div style={{ fontSize: 11, opacity: 0.85, textTransform: 'uppercase', letterSpacing: 0.5 }}>Chiffre d'Affaires Global</div>
                                    <div style={{ fontSize: 20, fontWeight: 700, marginTop: 4, whiteSpace: 'nowrap' }}>
                                        {numberWithCommas(totalChiffre)} F CFA
                                    </div>
                                    <div style={{ fontSize: 11, opacity: 0.8, marginTop: 2 }}>Total facturé</div>
                                </div>
                                <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: 8, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    <Icon type="dollar" style={{ fontSize: 20, color: '#fff' }} />
                                </div>
                            </div>
                        </AntCol>
                        <AntCol xs={24} sm={12} lg={6}>
                            <div style={{
                                background: 'linear-gradient(135deg, #fa8c16 0%, #d46b08 100%)',
                                borderRadius: 10,
                                padding: '16px 18px',
                                color: '#fff',
                                boxShadow: '0 4px 12px rgba(250, 140, 22, 0.25)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}>
                                <div style={{ minWidth: 0, flex: 1, paddingRight: 6 }}>
                                    <div style={{ fontSize: 11, opacity: 0.85, textTransform: 'uppercase', letterSpacing: 0.5 }}>Panier Moyen / Facture</div>
                                    <div style={{ fontSize: 20, fontWeight: 700, marginTop: 4, whiteSpace: 'nowrap' }}>
                                        {numberWithCommas(panierMoyen)} F CFA
                                    </div>
                                    <div style={{ fontSize: 11, opacity: 0.8, marginTop: 2 }}>Moyenne par facture</div>
                                </div>
                                <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: 8, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    <Icon type="shopping-cart" style={{ fontSize: 20, color: '#fff' }} />
                                </div>
                            </div>
                        </AntCol>
                        <AntCol xs={24} sm={12} lg={6}>
                            <div style={{
                                background: 'linear-gradient(135deg, #722ed1 0%, #531dab 100%)',
                                borderRadius: 10,
                                padding: '16px 18px',
                                color: '#fff',
                                boxShadow: '0 4px 12px rgba(114, 46, 209, 0.25)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}>
                                <div>
                                    <div style={{ fontSize: 11, opacity: 0.85, textTransform: 'uppercase', letterSpacing: 0.5 }}>Clients Distincts</div>
                                    <div style={{ fontSize: 22, fontWeight: 700, marginTop: 4 }}>{numberWithCommas(uniqueClients)}</div>
                                    <div style={{ fontSize: 11, opacity: 0.8, marginTop: 2 }}>Ayant commandé</div>
                                </div>
                                <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: 8, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Icon type="team" style={{ fontSize: 20, color: '#fff' }} />
                                </div>
                            </div>
                        </AntCol>
                    </AntRow>

                    {/* BARRE DE FILTRES ET ACTIONS */}
                    <div style={{
                        background: '#fafafa',
                        border: '1px solid #f0f0f0',
                        borderRadius: 8,
                        padding: '12px 16px',
                        marginBottom: 20,
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 12,
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center', flex: 1 }}>
                            <Input
                                prefix={<Icon type="search" style={{ color: '#bfbfbf' }} />}
                                placeholder="Rechercher par N°, référence, client, agent, agence..."
                                value={searchText}
                                onChange={this.handleSearch}
                                allowClear
                                style={{ width: 300, borderRadius: 6 }}
                            />
                            <RangePicker
                                style={{ borderRadius: 6 }}
                                defaultValue={[moment(startDate, dateFormat), moment(endDate, dateFormat)]}
                                format={dateFormat}
                                onChange={this.onDateChange}
                                ranges={{
                                    "Aujourd'hui": [moment(), moment()],
                                    'Cette Semaine': [moment().startOf('week'), moment().endOf('week')],
                                    'Ce Mois': [moment().startOf('month'), moment().endOf('month')],
                                    'Cette Année': [moment().startOf('year'), moment().endOf('year')]
                                }}
                            />
                            {(currentUser && currentUser.agence && currentUser.agence.enCours === true && currentUser.slug === "ADMIN_ROLE") &&
                                <Select
                                    value={codAgenceChange}
                                    showSearch
                                    style={{ width: 190 }}
                                    placeholder="Filtrer par Agence"
                                    optionFilterProp="children"
                                    onChange={this.handleChangeAgence}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Option value=''>TOUTES LES AGENCES</Option>
                                    {agences && agences.length ?
                                        agences.map((agence, k) => (
                                            <Option key={k} value={agence.codAgence}>{agence.nomAgence}</Option>
                                        )) : null
                                    }
                                </Select>
                            }
                            <Button icon="reload" onClick={this.handleRefresh} loading={isLoading} style={{ borderRadius: 6 }}>
                                Actualiser
                            </Button>
                        </div>
                        {use_logiciel === 'NO' &&
                            <Button
                                type="primary"
                                icon="plus"
                                style={{ borderRadius: 6, backgroundColor: '#52c41a', borderColor: '#52c41a', fontWeight: 600 }}
                                onClick={this.handleAddOpen}
                            >
                                NOUVEAU
                            </Button>
                        }
                    </div>

                    {/* TABLEAU DES FACTURES */}
                    <AntTable
                        columns={columnsFactures}
                        dataSource={filteredFactures}
                        rowKey={(record, index) => record.id || record.numFact || index}
                        loading={isLoading}
                        pagination={{
                            defaultPageSize: 15,
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '15', '25', '50', '100'],
                            showTotal: (total, range) => `${range[0]}-${range[1]} sur ${total} factures`
                        }}
                        scroll={{ x: 1200 }}
                        bordered
                        size="middle"
                        locale={{
                            emptyText: waitingEndMsg || "Aucune facture trouvée pour les critères sélectionnés"
                        }}
                    />
                </Card>


                <Modal
                    width={900}
                    visible={isAddModalVisible}
                    title="Facture Client"
                    //onOk={this.handleAddOpen}
                    onCancel={this.handleCancelAdd}
                    footer={[
                        <Button type="primary" loading={loading} onClick={this.handleAddFacture}>
                            Enrégistrer
                        </Button>,
                        <Button type="danger" onClick={this.handleCancelAdd}>
                            Annuler
                        </Button>,

                    ]}
                >
                    <Form>

                        <Row form>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="refFact">Référence Devis</Label>
                                    <Input type="text" name="refFact" value={refFact} onChange={this.handleChange} id="refFact" placeholder="" />
                                </FormGroup>

                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="dateFact">Date</Label>
                                    <Input disabled type="text" name="dateFact" id="dateFact" value={dateFact} onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>

                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="codClient">Client</Label>
                                    <InputGroup compact>

                                        <Select
                                            value={codClient}
                                            showSearch
                                            //style={{width: 200}}
                                            style={{ width: '75%' }}
                                            placeholder="Selectionner un Client"
                                            optionFilterProp="children"
                                            onChange={this.handleChangeClient}
                                            onFocus={this.handleFocus}
                                            onBlur={this.handleBlur}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {
                                                clients && clients.length ?
                                                    clients.map((client, k) => {
                                                        return <Option value={client.codClient}>{client.raisonSociale}</Option>
                                                    }) : null
                                            }

                                        </Select>
                                        <Button onClick={this.handleCancelAddClient} style={{ width: '25%' }} type="primary" ><i className="icon icon-add" /> AJOUTER</Button>
                                    </InputGroup>
                                </FormGroup>

                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="observation">Observation</Label>
                                    <Input type="text" name="observation" id="observation" value={observation} onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>

                        {/*<Row form>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="refFactFour">Facture Fournisseur N°</Label>
                                    <Input type="text" name="refFactFour" value={refFactFour} onChange={this.handleChange} id="refFactFour" placeholder="" />
                                </FormGroup>

                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="observation">Observation</Label>
                                    <Input type="text" name="observation" id="observation" value={observation} onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>

                        </Row>*/}

                        <Row form>
                            <Col md={6}>
                                <FormGroup >
                                    <Label for="modRegl">Type règlement</Label>
                                    <Select className="gx-mr-3 gx-mb-3" value={modRegl} onChange={this.handleChangeTypeReglement}>
                                        <Option value="Cash">Cash</Option>
                                        <Option value="Partiel">Partiel</Option>
                                        <Option value="Crédit">Crédit</Option>

                                    </Select>
                                    {//(modRegl === "A" || modRegl === "C" || modRegl === "E" || modRegl === "F") &&
                                        <h6 style={{ color: "black" }}><span>NB:Si la commande n'est pas payée à  l'avance, veuillez stipuler pour le Type de Règlement Crédit</span></h6>
                                    }

                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="codmod">Mode règlement</Label>
                                    <Select className="gx-mr-3 gx-mb-3" value={codmod} onChange={this.handleChangeModReglem}>
                                        <Option value="AUTRE">Autre</Option>
                                        <Option value="CARTE">Carte Bancaire</Option>
                                        <Option value="CHEQUE">Chèque</Option>
                                        <Option value="ESPECES">Espèces</Option>
                                        <Option value="MOMO">Mobile Money</Option>
                                        <Option value="VIREMENT">Virement</Option>
                                    </Select>

                                </FormGroup>
                            </Col>

                        </Row>


                        {/*<Row form>

                            <Col md={6}>
                                <FormGroup>
                                    <Label for="montantAp">Montant Commande</Label>
                                    <Input disabled type="number" name="montantAp" value={montantAp} id="montantAp" onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup >
                                    <Label for="idemBal">Montant règlement</Label>
                                    <Input type="text" name="idemBal" value="champ non retrouvé" id="idemBal" onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>*/}

                        <Row>
                            <Col md={8}>
                                <button className="btn waves-effect waves-light btn-rounded btn-primary ml-auto" onClick={this.openListArticleModal}><i className="icon icon-add" /> Ajouter Produit</button>
                            </Col>
                            <Col md={4} >

                                <FormItem label="Nbre d'Articles">
                                    <Input disabled type="number" name="nbresArticles" value={nbresArticles} id="nbresArticles" onChange={this.handleChange} />
                                </FormItem>

                            </Col>
                            <Col md={12}>
                                <Table hover responsive className="table-outline mb-0" striped>
                                    <thead className="bg-primary text-white">
                                        <tr>

                                            <th className="text-center d-none d-md-table-cell">Code</th>
                                            <th className="text-center">Désignation</th>
                                            <th className="text-center d-none d-md-table-cell">PU Brut</th>
                                            <th className="text-center d-none d-md-table-cell">Montant Remise</th>
                                            <th className="text-center d-none d-md-table-cell">PU Net HT</th>
                                            <th className="text-center">Qté Commandée</th>
                                            <th className="text-center">Montant</th>
                                            <th className="text-center d-none d-md-table-cell">Qté en Stock</th>
                                            <th className="text-center d-none d-md-table-cell">Tva</th>
                                            <th className="text-center">Retirer</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            listeArticlesSelected && listeArticlesSelected.length ?
                                                listeArticlesSelected.map((article, k) => {
                                                    //const puRevient = parseFloat(cleRepartition + article.puEntree)
                                                    return (
                                                        <tr key={k}>

                                                            <td className="d-none d-md-table-cell">{article.codProd}</td>
                                                            <td className="text-center">{article.designation}</td>
                                                            <td className="text-center d-none d-md-table-cell">{numberWithCommas(article.puBrut)}</td>
                                                            <td className="text-center d-none d-md-table-cell">{numberWithCommas(article.puRemise)}</td>
                                                            <td className="text-center d-none d-md-table-cell">{numberWithCommas(article.puUtilise)}</td>
                                                            <td className="text-center">{parseFloat(article.qtCommander)}</td>
                                                            <td className="text-center">{numberWithCommas(parseFloat(article.puUtilise) * parseFloat(article.qtCommander))}</td>
                                                            <td className="text-center d-none d-md-table-cell">{article.qteStock}</td>
                                                            <td className="text-center d-none d-md-table-cell">{article.tauxTva}</td>

                                                            <Button className="text-center" type="danger" onClick={() => this.handleDeleteArticlesSelected(article)}>
                                                                <i className="icon icon-close-circle" />
                                                            </Button>

                                                        </tr>
                                                    );
                                                })
                                                : null
                                        }
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>

                        <Row className="mt-3">
                            <Col md={5}>
                                <Card title="Groupe de Taxation et TVA" className="gx-card ">
                                    <Table hover responsive className="table-outline mb-0 d-none d-sm-table" style={{ display: 'flex', justifyContent: 'center' }} striped>
                                        <thead className="bg-primary text-white">
                                            <tr>
                                                {/**<th className="text-center"> </th> */}

                                                <th className="text-center">Base</th>
                                                <th className="text-center">Taux(%)</th>
                                                <th className="text-center">Montant</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                listeArticlesSelected && listeArticlesSelected.length ?
                                                    listeArticlesSelected.map((article, k) => {
                                                        return (
                                                            <tr key={k}>
                                                                {/** <td className="text-center"><Input onChange={(e) => this.handleChangeCheck(e, article)} className="ml-1" type="checkbox" /></td> */}

                                                                <td className="text-center">{numberWithCommas(parseFloat(article.puUtilise) * parseFloat(article.qtCommander))}</td>

                                                                <td className="text-center">{article.tauxTva}</td>

                                                                <td className="text-center">{numberWithCommas((parseFloat(article.puUtilise) * parseFloat(article.qtCommander) * parseFloat(article.tauxTva)) / 100)}</td>



                                                            </tr>
                                                        );
                                                    })
                                                    : null
                                            }

                                        </tbody>
                                    </Table>
                                    <FormItem className="mt-3" label="Total TVA"  {...formItemLayout}>
                                        <Input disabled type="number" name="totalTva" value={totalTva} id="totalTva" onChange={this.handleChange} placeholder="" />
                                    </FormItem>
                                </Card>

                            </Col>
                            <Col md={7}>
                                <Card title="Totaux et Taxes" className="gx-card">
                                    <FormItem label="Net HT"  {...formItemLayout}>

                                        <Input disabled type="number" name="netHT" id="netHT" value={netHT} onChange={this.handleChange} placeholder="" />
                                    </FormItem>
                                    {/*<FormItem label="Montant Remise"  {...formItemLayout}>

                                        <Input type="number" name="montantRemise" id="montantRemise" value={montantRemise} onChange={this.handleChange} placeholder="" />
                                    </FormItem>

                                    <FormItem label="Taux Remise"  {...formItemLayout}>

                                        <Input disabled type="number" name="tauxRemise" id="tauxRemise" value={tauxRemise} onChange={this.handleChange} placeholder="" />
                                        </FormItem>*/}

                                    <FormItem label="Net Commercial"  {...formItemLayout}>

                                        <Input disabled type="number" name="netCommercial" id="netCommercial" value={netCommercial} onChange={this.handleChange} placeholder="" />
                                    </FormItem>

                                    <FormItem label="Total TVA"  {...formItemLayout}>

                                        <Input disabled type="number" name="totalTva" value={totalTva} onChange={this.handleChange} placeholder="" />
                                    </FormItem>
                                    {/*<FormItem label="Frais Transport"  {...formItemLayout}>

                                        <Input type="number" name="fraisTransport" id="fraisTransport" value={fraisTransport} onChange={this.handleChange} placeholder="" />
                                    </FormItem>

                                    <FormItem label="Autres Frais"  {...formItemLayout}>

                                        <Input type="number" name="autreFrais" id="autreFrais" value={autreFrais} onChange={this.handleChange} placeholder="" />
                                    </FormItem>*/}

                                    <FormItem label="Montant TTC"  {...formItemLayout}>

                                        <Input disabled type="number" name="montantTtc" id="montantTtc" value={montantTtc} onChange={this.handleChange} placeholder="" />
                                    </FormItem>

                                    {/*<FormItem label="AIB"  {...formItemLayout}>

                                        <InputNumber name="tauxAib" id="tauxAib"
                                            value={tauxAib}
                                            onChange={this.handleChangeAib}
                                            formatter={value => `${value}%`}
                                            parser={value => value.replace('%', '')}
                                            defaultValue={0}
                                            min={0}
                                            max={100} />
                                        <Input disabled type="number" name="montantAib" id="montantAib" value={montantAib} onChange={this.handleChange} placeholder="Montant AIB" />
                                    </FormItem>
                                */}

                                    <FormItem label="Net à Payer"  {...formItemLayout}>

                                        <Input disabled type="number" name="netaPayer" id="netaPayer" value={netaPayer} onChange={this.handleChange} placeholder="" />
                                    </FormItem>
                                </Card>


                            </Col>
                        </Row>
                    </Form>
                </Modal>

                {/*<Modal
                    width={900}
                    visible={isUpdateModalVisible}
                    title="Modifier la Répartiton"
                    //onOk={this.handleAddOpen}
                    onCancel={this.handleCancelUpdate}
                    footer={[
                        <Button  type="primary" loading={loading} onClick={this.handleUpdateRepartition}>
                            Enrégistrer
                        </Button>,
                        <Button  type="danger" onClick={this.handleCancelUpdate}>
                            Annuler
                        </Button>,

                    ]}
                >
                    <Form>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="codAgence">Agence</Label>
                                    <InputGroup compact>

                                        <Select
                                            value={codAgence}
                                            showSearch
                                            //style={{width: 200}}
                                            style={{ width: '75%' }}
                                            placeholder="Selectionner une Agence"
                                            optionFilterProp="children"
                                            onChange={this.handleChangeClient}
                                            onFocus={this.handleFocus}
                                            onBlur={this.handleBlur}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {
                                                clients && clients.length ?
                                                    clients.map((agence, k) => {
                                                        return <Option value={agence.codAgence}>{agence.nomAgence}</Option>
                                                    }) : null
                                            }

                                        </Select>
                                        <Button onClick={this.handleCancelAddClient} style={{ width: '25%' }} type="primary" ><i className="icon icon-add" /> AJOUTER</Button>
                                    </InputGroup>
                                </FormGroup>

                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="observation">Observation</Label>
                                    <Input type="text" name="observation" id="observation" value={observation} onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row form>

                            <Col md={6}>
                                <FormGroup>
                                    <Label for="montantAp">Montant Commande</Label>
                                    <Input disabled type="number" name="montantAp" value={montantAp} id="montantAp" onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={8}>
                                <button className="btn waves-effect waves-light btn-rounded btn-primary ml-auto" onClick={this.openListArticleModal}><i className="icon icon-add" /> Ajouter Produit</button>
                            </Col>
                            <Col md={4} >

                                <FormItem label="Nbre d'Articles">
                                    <Input disabled type="number" name="nbresArticles" value={nbresArticles} id="nbresArticles" onChange={this.handleChange} />
                                </FormItem>

                            </Col>
                            <Col md={12}>
                                <Table hover responsive className="table-outline mb-0 d-none d-sm-table" style={{ display: 'flex', justifyContent: 'center' }} striped>
                                    <thead className="bg-secondary text-black">
                                        <tr>

                                            <th className="text-center">Code</th>
                                            <th className="text-center">Désignation</th>
                                            <th className="text-center">Qté à Répartir</th>
                                            <th className="text-center">Qté Potentiel Stock</th>
                                            <th className="text-center">Qté Potentiel Restant</th>
                                            <th className="text-center">Retirer</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            listeArticlesSelected && listeArticlesSelected.length ?
                                                listeArticlesSelected.map((article, k) => {
                                                    //const puRevient = parseFloat(cleRepartition + article.puEntree)
                                                    return (
                                                        <tr key={k}>

                                                            <td>{article.codProd}</td>
                                                            <td className="text-center">{article.designation}</td>
                                                            <td className="text-center">{article.qtEntree}</td>
                                                            <td className="text-center">{parseFloat(article.qteStock) - parseFloat(article.qteStockEnCoursValidation) + parseFloat(article.qtEntree)}</td>

                                                            <td className="text-center">{parseFloat(article.qteStock) - parseFloat(article.qteStockEnCoursValidation)}</td>

                                                            <Button className="text-center" type="danger" onClick={() => this.handleDeleteArticlesSelected(article)}>
                                                                <i className="icon icon-close-circle" />
                                                            </Button>

                                                        </tr>
                                                    );
                                                })
                                                : null
                                        }
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>

                    </Form>
                                    </Modal>*/}

                <Modal
                    width={950}
                    visible={isModalVisible}
                    title={
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: 24 }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Icon type="file-done" style={{ color: '#1890ff', fontSize: 20, marginRight: 8 }} />
                                <span style={{ fontWeight: 700, fontSize: 17, color: '#1f1f1f' }}>
                                    Détails Facture N° {numFact || '-'}
                                </span>
                            </div>
                            <Tag color="geekblue" style={{ fontFamily: 'monospace', fontWeight: 600, fontSize: 13, padding: '2px 10px' }}>
                                Réf: {refFact || '-'}
                            </Tag>
                        </div>
                    }
                    onOk={this.handleCancel}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="close" type="primary" onClick={this.handleCancel} style={{ borderRadius: 6, padding: '0 24px' }}>
                            Fermer
                        </Button>
                    ]}
                >
                    {/* EN-TETE INFOS CLIENT & FACTURE */}
                    <div style={{
                        background: '#fafafa',
                        border: '1px solid #f0f0f0',
                        borderRadius: 8,
                        padding: '16px 20px',
                        marginBottom: 20
                    }}>
                        <AntRow gutter={[16, 12]}>
                            <AntCol xs={24} sm={12} md={8}>
                                <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', fontWeight: 600 }}>Client</div>
                                <div style={{ fontSize: 14, fontWeight: 600, color: '#262626', marginTop: 2, display: 'flex', alignItems: 'center' }}>
                                    <Icon type="user" style={{ color: '#1890ff', marginRight: 6 }} />
                                    {clientName || (() => {
                                        const cObj = clients && clients.find(c => c.codClient === codClient || c.id === codClient);
                                        return cObj ? cObj.raisonSociale : codClient || 'Client Ordinaire';
                                    })()}
                                </div>
                            </AntCol>
                            <AntCol xs={24} sm={12} md={8}>
                                <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', fontWeight: 600 }}>Agence</div>
                                <div style={{ marginTop: 2 }}>
                                    <Tag color="blue" style={{ fontSize: 12 }}>{nomAgence || '-'}</Tag>
                                </div>
                            </AntCol>
                            <AntCol xs={24} sm={12} md={8}>
                                <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', fontWeight: 600 }}>Date d'émission</div>
                                <div style={{ fontSize: 13, fontWeight: 500, color: '#262626', marginTop: 2, display: 'flex', alignItems: 'center' }}>
                                    <Icon type="calendar" style={{ color: '#52c41a', marginRight: 6 }} />
                                    {dateFact ? moment(new Date(dateFact), 'DD/MM/YYYY').format('DD/MM/YYYY') : '-'}
                                </div>
                            </AntCol>
                            <AntCol xs={24} sm={12} md={8}>
                                <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', fontWeight: 600 }}>Agent / Caissier</div>
                                <div style={{ fontSize: 13, fontWeight: 500, color: '#262626', marginTop: 2 }}>
                                    {nomAgent || '-'}
                                </div>
                            </AntCol>
                            <AntCol xs={24} sm={12} md={8}>
                                <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', fontWeight: 600 }}>Type & Mode Règlement</div>
                                <div style={{ marginTop: 2, display: 'flex', gap: 6 }}>
                                    <Tag color="cyan">{modRegl || 'Cash'}</Tag>
                                    <Tag color="purple">{codmod || 'ESPECES'}</Tag>
                                </div>
                            </AntCol>
                            {observation ? (
                                <AntCol xs={24} sm={12} md={8}>
                                    <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', fontWeight: 600 }}>Observation</div>
                                    <div style={{ fontSize: 13, color: '#595959', marginTop: 2 }}>
                                        {observation}
                                    </div>
                                </AntCol>
                            ) : null}
                        </AntRow>
                    </div>

                    {/* TABLEAU DES ARTICLES */}
                    <div style={{ marginBottom: 20 }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                            <h4 style={{ margin: 0, fontWeight: 700, color: '#262626', fontSize: 14 }}>
                                <Icon type="shopping-cart" style={{ marginRight: 6, color: '#1890ff' }} />
                                Articles Facturés ({listeArticlesSelected ? listeArticlesSelected.length : 0})
                            </h4>
                            <span style={{ fontSize: 12, color: '#8c8c8c' }}>
                                Total Unités : <b>{nbresArticles}</b>
                            </span>
                        </div>
                        <AntTable
                            columns={[
                                {
                                    title: 'Code',
                                    dataIndex: 'codProd',
                                    key: 'codProd',
                                    width: 100,
                                    render: (text) => <Tag style={{ fontFamily: 'monospace' }}>{text || '-'}</Tag>
                                },
                                {
                                    title: 'Désignation',
                                    dataIndex: 'designation',
                                    key: 'designation',
                                    render: (text) => <span style={{ fontWeight: 600, color: '#262626' }}>{text || '-'}</span>
                                },
                                {
                                    title: 'PU Brut',
                                    dataIndex: 'puBrut',
                                    key: 'puBrut',
                                    align: 'right',
                                    render: (val) => `${numberWithCommas(parseFloat(val || 0))} F`
                                },
                                {
                                    title: 'Montant Remise',
                                    dataIndex: 'puRemise',
                                    key: 'puRemise',
                                    align: 'right',
                                    render: (val) => parseFloat(val) > 0 ? (
                                        <span style={{ color: '#fa8c16', fontWeight: 500 }}>-{numberWithCommas(parseFloat(val))} F</span>
                                    ) : <span style={{ color: '#bfbfbf' }}>-</span>
                                },
                                {
                                    title: 'PU Net HT',
                                    dataIndex: 'puUtilise',
                                    key: 'puUtilise',
                                    align: 'right',
                                    render: (val) => <span style={{ fontWeight: 500 }}>{numberWithCommas(parseFloat(val || 0))} F</span>
                                },
                                {
                                    title: 'Qté',
                                    dataIndex: 'qtCommander',
                                    key: 'qtCommander',
                                    align: 'center',
                                    width: 80,
                                    render: (val) => <Tag color="blue" style={{ fontWeight: 700 }}>{parseFloat(val || 0)}</Tag>
                                },
                                {
                                    title: 'Montant Total',
                                    key: 'totalLigne',
                                    align: 'right',
                                    render: (text, row) => (
                                        <span style={{ fontWeight: 700, color: '#096dd9', whiteSpace: 'nowrap' }}>
                                            {numberWithCommas(parseFloat(row.puUtilise || 0) * parseFloat(row.qtCommander || 0))} F CFA
                                        </span>
                                    )
                                },
                                {
                                    title: 'TVA',
                                    dataIndex: 'tauxTva',
                                    key: 'tauxTva',
                                    align: 'center',
                                    width: 70,
                                    render: (val) => <Tag color="orange">{val || 0}%</Tag>
                                }
                            ]}
                            dataSource={listeArticlesSelected || []}
                            rowKey={(record, index) => record.codProd || index}
                            pagination={false}
                            bordered
                            size="small"
                        />
                    </div>

                    {/* SECTION FISCALITE & TOTAUX */}
                    <AntRow gutter={[16, 16]}>
                        <AntCol xs={24} md={10}>
                            <Card
                                title={<span style={{ fontSize: 13, fontWeight: 700 }}>Fiscalité & TVA</span>}
                                size="small"
                                bordered
                                style={{ borderRadius: 8, height: '100%' }}
                            >
                                <AntTable
                                    columns={[
                                        {
                                            title: 'Base HT',
                                            key: 'base',
                                            align: 'right',
                                            render: (text, row) => `${numberWithCommas(parseFloat(row.puUtilise || 0) * parseFloat(row.qtCommander || 0))} F`
                                        },
                                        {
                                            title: 'Taux',
                                            dataIndex: 'tauxTva',
                                            key: 'tauxTva',
                                            align: 'center',
                                            render: (val) => `${val || 0}%`
                                        },
                                        {
                                            title: 'Montant',
                                            key: 'montantTva',
                                            align: 'right',
                                            render: (text, row) => `${numberWithCommas(((parseFloat(row.puUtilise || 0) * parseFloat(row.qtCommander || 0) * parseFloat(row.tauxTva || 0)) / 100))} F`
                                        }
                                    ]}
                                    dataSource={listeArticlesSelected || []}
                                    rowKey={(record, index) => index}
                                    pagination={false}
                                    size="small"
                                />
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 8px 4px', fontWeight: 600, fontSize: 13, borderTop: '1px solid #f0f0f0', marginTop: 8 }}>
                                    <span>Total TVA :</span>
                                    <span style={{ color: '#d46b08' }}>{numberWithCommas(parseFloat(totalTva || 0))} F CFA</span>
                                </div>
                            </Card>
                        </AntCol>

                        <AntCol xs={24} md={14}>
                            <Card
                                title={<span style={{ fontSize: 13, fontWeight: 700 }}>Récapitulatif Financier</span>}
                                size="small"
                                bordered
                                style={{ borderRadius: 8 }}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, padding: '4px 8px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#595959' }}>
                                        <span>Net HT :</span>
                                        <span style={{ fontWeight: 600, color: '#262626' }}>{numberWithCommas(parseFloat(netHT || 0))} F CFA</span>
                                    </div>
                                    {parseFloat(montantRemise || 0) > 0 && (
                                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#fa8c16' }}>
                                            <span>Montant Remise :</span>
                                            <span style={{ fontWeight: 600 }}>-{numberWithCommas(parseFloat(montantRemise || 0))} F CFA</span>
                                        </div>
                                    )}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#595959' }}>
                                        <span>Net Commercial :</span>
                                        <span style={{ fontWeight: 600, color: '#262626' }}>{numberWithCommas(parseFloat(netCommercial || netHT || 0))} F CFA</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#595959' }}>
                                        <span>Total TVA :</span>
                                        <span style={{ fontWeight: 600, color: '#262626' }}>{numberWithCommas(parseFloat(totalTva || 0))} F CFA</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#595959' }}>
                                        <span>Montant TTC :</span>
                                        <span style={{ fontWeight: 600, color: '#262626' }}>{numberWithCommas(parseFloat(montantTtc || 0))} F CFA</span>
                                    </div>

                                    {/* GRAND BANDEAU NET A PAYER */}
                                    <div style={{
                                        background: 'linear-gradient(135deg, #f6ffed 0%, #e6f7ff 100%)',
                                        border: '1.5px solid #b7eb8f',
                                        borderRadius: 8,
                                        padding: '12px 16px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginTop: 8
                                    }}>
                                        <div>
                                            <div style={{ fontSize: 11, color: '#52c41a', textTransform: 'uppercase', fontWeight: 700, letterSpacing: 0.5 }}>Net à Payer</div>
                                            <div style={{ fontSize: 11, color: '#8c8c8c' }}>{modRegl} - {codmod}</div>
                                        </div>
                                        <div style={{ fontSize: 22, fontWeight: 800, color: '#389e0d', whiteSpace: 'nowrap' }}>
                                            {numberWithCommas(parseFloat(netaPayer || montFact || 0))} F CFA
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </AntCol>
                    </AntRow>
                </Modal>

                <Modal
                    width={800}
                    visible={isAddClientModalVisible}
                    title="Ajouter un Client"
                    //onOk={this.handleAddOpen}
                    onCancel={this.handleCancelAddClient}
                    footer={[
                        <Button type="primary" loading={loading} onClick={this.handleAddClient}>
                            Enrégistrer
                        </Button>,
                        <Button type="danger" onClick={this.handleCancelAddClient}>
                            Annuler
                        </Button>,

                    ]}
                >
                    <Form>
                        <Row form>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="raisonSociale">Raison Sociale</Label>
                                    <Input type="text" name="raisonSociale" id="raisonSociale" value={raisonSociale} onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="ifu">IFU</Label>
                                    <Input maxLength={13} type="number" name="ifu" value={ifu} id="ifu" onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>
                        {/*<Row form>
                            <Col md={12}>
                                <FormGroup>
                                    <Label for="numeroCarte">Numéro Carte</Label>
                                    <Input type="number" name="numeroCarte" id="numeroCarte" value={numeroCarte} onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                </Row>*/}
                        <Row>
                            <Col md={6}>
                                <FormGroup >
                                    <Label for="gender">Sexe</Label>
                                    <Select className="gx-mr-6 gx-mb-6" value={gender} onChange={this.handleChangeGender}>
                                        <Option value="M">Masculin</Option>
                                        <Option value="F">Feminin</Option>
                                    </Select>
                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <Label for="dateNaissance">Date de Naissance</Label>
                                <FormGroup>

                                    <DatePicker style={{ width: '100%' }} name="dateNaissance" id="dateNaissance" value={moment(dateNaissance, dateFormatList[0])} locale={locale} onChange={this.handleChangeDate} format={dateFormatList} />
                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <FormGroup>
                                    <Label for="adresse">Adresse</Label>
                                    <Input type="text" name="adresse" value={adresse} onChange={this.handleChange} id="adresse" placeholder="" />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="profession">Profession</Label>
                                    <Input type="text" name="profession" id="profession" value={profession} onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>



                        <Row form>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="contact">Téléphone</Label>
                                    <Input type="text" name="contact" id="contact" value={contact} onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="contact2">Téléphone 2</Label>
                                    <Input type="text" name="contact2" value={contact2} id="contact2" onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>


                        <Row form>

                            <Col md={6}>
                                <FormGroup>
                                    <Label for="email">Email</Label>
                                    <Input type="text" name="email" value={email} id="email" onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="siteWeb">Site web</Label>
                                    <Input type="text" name="siteWeb" id="siteWeb" value={siteWeb} onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row form>

                            <Col md={6}>
                                <FormGroup>
                                    <Label for="typeClient">Type de Client</Label>
                                    <Select
                                        value={typeClient}
                                        className="gx-mr-6 gx-mb-6"
                                        placeholder="Selectionner un Type"
                                        onChange={this.handleChangeTypeClient}
                                    >
                                        <Option value="CLIENT DETAILLANT">CLIENT DETAILLANT</Option>
                                        <Option value="CLIENT EN GROS">CLIENT EN GROS</Option>
                                        <Option value="CLIENT ORDINAIRE">CLIENT ORDINAIRE</Option>

                                    </Select>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <Label for="mentionClient">Mention Client</Label>
                                <FormGroup>

                                    <Radio.Group
                                    // options={optionsWithDisabled}
                                    // onChange={this.onChangeMention}
                                    //value={mentionClient}
                                    //optionType="button"
                                    //buttonStyle="solid"
                                    />
                                    <Radio.Group onChange={this.onChangeMention} value={mentionClient} defaultValue={mentionClient} buttonStyle="solid">
                                        <Radio.Button value="">Aucune option</Radio.Button>
                                        <Radio.Button value="NOUVEAU CLIENT">Nouveau Client</Radio.Button>
                                        <Radio.Button value="ANCIEN CLIENT">Ancien Client</Radio.Button>
                                    </Radio.Group>
                                </FormGroup>
                            </Col>
                            {/*<Col md={6}>
                                <FormGroup>
                                    <Label for="usuel">Usuel</Label>
                                    <Select

                                        value={usuel}
                                        className="gx-mr-6 gx-mb-6"
                                        placeholder="Selectionner une valeur"

                                        onChange={this.handleChangeUsuel}
                                    >
                                        <Option value="1">Usuel</Option>
                                        <Option value="0">Non Usuel</Option>
                                    </Select>
                                </FormGroup>
                         </Col> */}
                        </Row>


                        {/*<Row form>

              <Col md={12}>
                <FormGroup>
                  <Label for="codClient">Agences</Label>
                  <InputGroup compact>

                    <Select

                      value={codClient}
                      showSearch
                      //style={{width: 200}}
                      style={{ width: '85%' }}
                      placeholder="Selectionner Agence"
                      optionFilterProp="children"
                      onChange={this.handleChangeAgence}
                      onFocus={this.handleFocus}
                      onBlur={this.handleBlur}
                      filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                      {
                        agences && agences.length ?
                          agences.map((agence, k) => {
                            return <Option value={agence.codClient}>{agence.nomAgence}</Option>
                          }) : null
                      }

                    </Select>
                    <Button onClick={this.OpenModalAddAgence} style={{ width: '15%' }} type="primary" ><i className="icon icon-add" /> AJOUTER</Button>
                  </InputGroup>
                </FormGroup>

              </Col>
                    </Row>*/}

                    </Form>
                </Modal>

                <Modal
                    width={700}
                    visible={isListArticleVisible}
                    title="Liste Produits"
                    //onOk={this.handleAddOpen}
                    onCancel={this.openListArticleModal}
                    footer={[
                        /* <Button  type="primary" loading={loading} onClick={this.handleUpdateRepartition}>
                             Enrégistrer
                         </Button>,*/
                        <Button type="danger" onClick={this.openListArticleModal}>
                            Fermer
                        </Button>,

                    ]}
                >

                    <Row>
                        <Col md={12}>
                            <Input onChange={this.onRechercheArticleChange} type='text' placeholder='Rechercher' style={{ width: '100%' }} /> <hr />
                        </Col>
                    </Row>
                    <Row style={{ height: '300px', overflow: 'auto' }}>

                        <Col md={12}>
                            <ListGroup>
                                <Table hover responsive className="table-outline mb-0" striped>
                                    <thead className="bg-primary text-white">
                                        <tr>
                                            <th className="text-center">Produits</th>
                                            <th className="text-center d-none d-md-table-cell">Stock Actuel</th>
                                            {currentUser && currentUser.agence && currentUser.agence.enCours === true &&
                                                <th className="text-center d-none d-md-table-cell">Stock En Validation</th>
                                            }
                                            {currentUser && currentUser.agence && currentUser.agence.enCours === true &&
                                                <th className="text-center">Stock Restant</th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            articles && articles.length ?
                                                articles.map((article, k) => {
                                                    return article.article && article.article.designation &&
                                                        <tr key={k} id={k} onClick={(e) => this.openDetailArticleModal(article)} style={{ cursor: "pointer" }}>
                                                            <td className="text-center">{article.article ? article.article.designation : ''}</td>
                                                            <td className="text-center d-none d-md-table-cell">{article.qteStock}</td>
                                                            {currentUser && currentUser.agence && currentUser.agence.enCours === true &&
                                                                <td className="text-center d-none d-md-table-cell">{article.qteStockEnCoursValidation}</td>
                                                            }
                                                            {currentUser && currentUser.agence && currentUser.agence.enCours === true &&
                                                                <td className="text-center">{parseFloat(article.qteStock) - parseFloat(article.qteStockEnCoursValidation)}</td>
                                                            }
                                                        </tr>
                                                }) : null
                                        }

                                    </tbody>
                                </Table>

                            </ListGroup>

                        </Col>


                    </Row>
                </Modal>

                <Modal
                    width={500}
                    visible={isDetailsArticleVisible}
                    title={titleDetailsArticle}
                    //onOk={this.handleAddOpen}
                    onCancel={this.closeDetailArticleModal}
                    footer={[
                        <Button type="primary" loading={loading} onClick={this.handleArticleSelected}>
                            Ajouter
                        </Button>,
                        <Button type="danger" onClick={this.closeDetailArticleModal}>
                            Annuler
                        </Button>,

                    ]}
                >
                    <Form>
                        <Row form>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="qteStock">Stok Potentiel Restant</Label>
                                    <Input disabled type="number" name="qteStock" value={parseFloat(qteStock) - parseFloat(qteStockEnCoursValidation)} onChange={this.handleChange} id="qteStock" placeholder="" />
                                </FormGroup>
                            </Col>
                            <Col md={8}>
                                <FormGroup>
                                    <Label for="qtCommander">Qté Commandée</Label>
                                    <Input type="number" name="qtCommander" id="qtCommander" value={qtCommander} onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>

                        </Row>
                        <Row form>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="puBrut">PU Brut</Label>
                                    <Input disabled type="number" name="puBrut" value={puBrut} onChange={this.handleChange} id="puBrut" placeholder="" />
                                </FormGroup>
                            </Col>
                            <Col md={8}>
                                <FormGroup>
                                    <Label for="puRemise">Montant Remise</Label>
                                    <Input type="number" name="puRemise" id="puRemise" value={puRemise} onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>

                        </Row>
                    </Form>
                </Modal>

                <Modal
                    width={400}
                    visible={isValidationValidation}
                    title="Validation Répartition"
                    //onOk={this.handleAddOpen}
                    onCancel={this.handleCloseValidation}
                    footer={[
                        <Button type="primary" loading={loading} onClick={this.handleValiderRepartition}>
                            Valider
                        </Button>,
                        <Button type="danger" onClick={this.handleCloseValidation}>
                            Annuler
                        </Button>,

                    ]}
                >
                    <h5>
                        Voulez vous valider cette Répartition...?
                    </h5>
                </Modal>


            </div>
        )
    }
}


export default FacturePrincipal;
